import { api } from '../initFetch'

/**
 * 
 * @param {string} token - teams access token
 * @param {string} tenantId - tenant id
 * @param {string} teamId - teams id
 * @param {string} channelId - channel id
 * @param {string} itemPath - item path in channel
 * @param {Blob} docBlobRef - document blob reference
 * @param {string} name - file name
 * @returns {Promise<object>} - upload response
 */
export const uploadToChannel = async (
  token,
  tenantId,
  teamId = null,
  channelId = null,
  itemPath = null,
  docBlobRef,
  name
) => {
  const res = await api.post('/p4m/Teams/UploadToChannel', {
    token,
    tenantId,
    channelId,
    teamId,
    itemPath,
    docBlobRef,
    name,
  })
  return res.json
}
